import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Card, CardActions, CardContent, Button } from '@material-ui/core';
import Link from 'gatsby-link';

const styles = {
  card: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
};

function EventCard(props) {
  const { classes } = props;
  const data = props.data;

  return (
    <div>
      <Card className={classes.card}>
        <CardContent>

          <Typography variant="headline" component="h2">
            {data.name}
          </Typography>

          <Typography className={classes.pos} color="textSecondary">
            {data.dates}
          </Typography>

          <Typography variant="headline" component="h4">
            {data.price}
          </Typography>
        </CardContent>

        <CardActions>
              <Button component={Link} to={data.eventKey}>Vaata järgi...</Button>
        </CardActions>
      </Card>
    </div>
  );
}

EventCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EventCard);



// WEBPACK FOOTER //
// ./src/components/EventCard.js